import axios from "axios";
import { apiGateway } from "../../app/conf";
import { attachResponseInterceptor } from "./interceptors";

const axiosGatewayInstance = axios.create({
  baseURL: `${apiGateway}/api`,
});

attachResponseInterceptor(axiosGatewayInstance);

export default axiosGatewayInstance;
